export default __webpack_public_path__ + "static/media/3c9fc09e4b93038b.53b8b02f7ee781615c940eba9664b049.svg";